import React, { useEffect, useRef, useState } from "react";
import { withRouter, useHistory, useLocation} from "react-router-dom";

import RangeAreaChart from './Charts/RangeAreaChart';
import StackedBarChart from "./Charts/StackedBarChart";

import { requestGet, agmsClientRequestGet, agmsClientRequestPost } from "../../apis/request";
import {atom, useRecoilState} from 'recoil';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Unstable_Grid2';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import secureLocalStorage from "react-secure-storage";
import {isCurrentBloodSugarAtom, seletedPatientIdState, useRefStateAtom} from '../../states/recoilState';
import CircularProgress from '@mui/material/CircularProgress';
import USER_IDENTITY from '../../constants/Constants';
import { useTranslation } from "react-i18next";
const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    //color: theme.palette.text.secondary,
    border: '1.5px solid #5E2589',
}));

const CGMreport = () => {
    const { t:translate, i18n } = useTranslation();
    const [graphLoading, setGraphLoading] = useState(true);
    const [useRefState, setUseRefState] = useRecoilState(useRefStateAtom);
    const componentRef = useRef();

    const history = useHistory();
    const location = useLocation();
    const [dataObject, setDataObject] = useState({
        hospitalName: '',
        patientName: '',
        identification: '',
        startDate: '',
        endDate: '',
        deviceType: '',
        deviceSerialNumber: '',
        activePercent: '',
        measurementPeriod: 1,

        avgGlucose: null,
        maxGlucose: null,
        minGlucose: null,
        measurementPeriod: null,
        exceedUpperPercent: null,
        exceedUpperTime: null,
        exceedLowerPercent: null,
        exceedLowerTime: null,
        totalMeasurementTime: '0',
    });
    const [stackedGraphData, setStackedGraphData] = useState({
        countVeryHighPercent: 0,
        countHighPercent: 0,
        countTargetPercent: 0,
        countLowPercent: 0,
        countVeryLowPercent: 0,
    });

    const [selectedPatientId, setSeletedPatientId] = useRecoilState(seletedPatientIdState);
    const [isCurrentBloodSugar, setIsCurrentBloodSugar] = useRecoilState(isCurrentBloodSugarAtom);


    //요약 그래프용
    const [lineSeriesData, setLineSeriesData] = useState([]);
    const [middleAreaSeriesData, setMiddleAreaSeriesData] = useState([]);
    const [mainUpperAreaSeriesData, setUpperMainAreaSeriesData] = useState([]);
    const [mainLowerAreaSeriesData, setLowerMainAreaSeriesData] = useState([]);

    const [upperLimit, setUpperLimit]= useState([]);
    const [lowerLimit, setLowerLimit]= useState([]);


    
    //유저 정보
    const [userInfo, setUserInfo] = useState({
        name : '',
        sex : '',
        height : 0,
        weight : 0,
        email : ''
    });
    //유저 정보
    const callUserApi = async() => {
        // 관리자가 환자를 보고 있으면 그 환자(adminViewUserId)로 조회, 아니면 로그인 계정. (WeeklyChartList와 동일 패턴)
        const graphUserId = secureLocalStorage.getItem('adminViewUserId') ?? (USER_IDENTITY === null ? secureLocalStorage.getItem('authUser') : USER_IDENTITY);
        let result = await agmsClientRequestGet(
            `/api/user/info?user_id=${graphUserId}`
        );

        //1601 남성
        //1602 여성
        //1603 선택 안함
        let object = {
            name : result.name,
            sex : result.sex,
            height : result.height + ' cm',
            weight : result.weight + ' kg',
            email : result.email
        }

        secureLocalStorage.setItem('userInfo', object);
        setUserInfo(object);
    }

    const callCGMreportApi = async (input) => {
        let result = null;
        setGraphLoading(true);
        // if(!isCurrentBloodSugar){
            
        // }else{
        //     result = await agmsClientRequestGet(`/api/report/statistic/${input}?strValueType=1308`);
        // }

        // 관리자가 환자를 보고 있으면 그 환자(adminViewUserId)로 조회, 아니면 로그인 계정. (WeeklyChartList와 동일 패턴)
        const graphUserId = secureLocalStorage.getItem('adminViewUserId') ?? (USER_IDENTITY === null ? secureLocalStorage.getItem('authUser') : USER_IDENTITY);
        result = await agmsClientRequestGet(`/api/graph/statistic?user_id=${graphUserId}&started_dt=${secureLocalStorage.getItem('userDeviceStartDate')}`);
        
     
        setUpperLimit(result.upperLimit);
        setLowerLimit(result.lowerLimit);

        //Area그래프에 props로 넘겨줄 데이터를 가공합니다.
        if(result.is_success){
            let tempLineList = [];
            let tempMiddelAreaList = [];
            let tempUpperMainAreaList = [];
            let tempLowerMainAreaList = [];

            for(let i = 0; i < result.profileGraphData["50%"].length; i+=4) {
                // AGP 프로파일 x축은 "하루 24시간" 더미 축(서버 시각 아님) — 2022-01-02 기준 + 15분 간격.
                // datetimeUTC:true 와 짝이라 그대로 둔다(UTC-first 무관).
                let beforeUtcTempDate = new Date("2022-01-02T00:00:00");
                let tempDate = new Date(Date.UTC(beforeUtcTempDate.getFullYear(), beforeUtcTempDate.getMonth(),beforeUtcTempDate.getDate(),beforeUtcTempDate.getHours(),beforeUtcTempDate.getMinutes(),beforeUtcTempDate.getSeconds()));
                tempDate.setMinutes(tempDate.getMinutes() + 15 * i);

                let tempObject = {
                    x: tempDate,
                    y: Math.floor(result.profileGraphData["50%"][i])
                }
                tempLineList.push(tempObject);
                
                let tempObject1 = {
                    x: tempDate,
                    y: [ Math.floor(result.profileGraphData["25%"][i]),  Math.floor(result.profileGraphData["75%"][i]) ] 
                }
                tempMiddelAreaList.push(tempObject1);

                let tempObject2 = {
                    x: tempDate,
                    y: [ Math.floor(result.profileGraphData["75%"][i]),  Math.floor(result.profileGraphData["95%"][i]) ] 
                }
                tempUpperMainAreaList.push(tempObject2);

                let tempObject3 = {
                    x: tempDate,
                    y: [ Math.floor(result.profileGraphData["5%"][i]),  Math.floor(result.profileGraphData["25%"][i]) ] 
                }
                tempLowerMainAreaList.push(tempObject3);
                
                setLineSeriesData(tempLineList);
                setMiddleAreaSeriesData(tempMiddelAreaList);
                setUpperMainAreaSeriesData(tempUpperMainAreaList);
                setLowerMainAreaSeriesData(tempLowerMainAreaList);
            }
        }
        else{
            setGraphLoading(false);
        }
        const match_totalMeasurementTime = result.totalMeasurementTime.match(/(\d+)\s*시간\s*(\d+)\s*분/);
        const match_exceedUpper = result.exceedUpperTime.match(/(\d+)\s*시간\s*(\d+)\s*분/);
        const match_exceedLower = result.exceedLowerTime.match(/(\d+)\s*시간\s*(\d+)\s*분/);
         
        let hour = 0;
        let minute = 0;

        if (match_totalMeasurementTime) {
            hour = Number(match_totalMeasurementTime[1]);
            minute = Number(match_totalMeasurementTime[2]);
        }
        result.totalMeasurementTime = `${hour} ${translate('hour')} ${minute} ${translate('minute')}`;


        if (match_exceedUpper) {
            hour = Number(match_exceedUpper[1]);
            minute = Number(match_exceedUpper[2]);
        }
        result.exceedUpperTime = `${hour} ${translate('hour')} ${minute} ${translate('minute')}`;

        if (match_exceedLower) {
            hour = Number(match_exceedLower[1]);
            minute = Number(match_exceedLower[2]);
        }
        result.exceedLowerTime = `${hour} ${translate('hour')} ${minute} ${translate('minute')}`;
        setDataObject(result);
        setStackedGraphData(
            {
                countVeryHighPercent: result.countVeryHighPercent,
                countHighPercent: result.countHighPercent,
                countTargetPercent: result.countTargetPercent,
                countLowPercent: result.countLowPercent,
                countVeryLowPercent: result.countVeryLowPercent,
            }
        );
        setGraphLoading(false);
    }

    // useEffect(()=>{
        
    // },[stackedGraphData]);

    // useEffect(()=>{        
    //     callCGMreportApi(secureLocalStorage.getItem("selectedPatientId"));
    // },[selectedPatientId]);

    useEffect(()=>{ 
        callCGMreportApi();
        callUserApi();
        setUseRefState(componentRef.current);
    },[]);

    const handleToWeeklyChart = () =>{
        history.push('/weeklyChartList/list');
    }
    return (
    <div ref={componentRef}>
        <div
            className="row w-100"
            style={{ padding: "0px 70px", marginTop: "30px", height:'1100px' }}
        >
            <div className="panel-body"  style={{maxWidth:'1500px', minWidth:'1400px', marginLeft:'auto', marginRight:'auto'}}>
                <Stack spacing={{ xs: 1, sm: 2 }} style={{ height:'3000'}}>
                    <Box style={{width: '100%', display:'flex'}}>
                        <Card style={{flex : 1 , display:'flex', justifyContent:'center', alignItems:'center', flexDirection:'column', border: '1px solid #5E2589', marginRight:'10px'}}>
                                {graphLoading == true ?  <CircularProgress/>:
                                <>
                                    <div style={{width:'100%', flex : 1, paddingLeft:'30px', display:'flex', alignItems:'center', fontSize:'16px'}}>
                                        <b>{translate('within_the_measurement_period')} {','} {isCurrentBloodSugar ? translate('glucose') : translate('current')} {translate('distribution')}</b>
                                    </div>
                                    <div style={{width:'100%', flex : 3, display:'flex', alignItems:'center'}}>
                                        <StackedBarChart stackedGraphData = {stackedGraphData}/>
                                    </div>
                                </>
                                }
                        </Card>
                        <Card style={{flex : 1, marginLeft:'10px', border: '1px solid #5E2589'}}>
                            <CardContent>
                                <div style={{display:'flex', fontWeight:'bold', fontSize:'16px'}}>
                                    <div style={{flex:1}}>
                                        {translate('name')}: {userInfo.name} 
                                    </div>
                                   
                                </div>
                                
                                <hr></hr>
                                
                                <div style={{display:'flex', fontWeight:'bold', fontSize:'16px'}}>
                                    <div style={{flex: 1}}>
                                        {translate('measurement_period')} : {dataObject.startDate} ~ {dataObject.endDate} ({dataObject.measurementPeriod} {translate('day')})
                                    </div>
                                    {/* <div style={{flex: 1}}>
                                    
                                    </div> */}
                                </div>

                                <hr></hr>

                                <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                                    <Grid xs={4}>
                                        <Item>
                                            <div>
                                                <b>{translate('average_cgm')} {' '} {isCurrentBloodSugar ? translate('glucose'): '전류'}</b>
                                            </div>
                                            <div>
                                                {Math.round(dataObject.avgGlucose)} {isCurrentBloodSugar ? 'mg/dL': 'nA'}
                                            </div>
                                        </Item>
                                    </Grid>
                                    <Grid xs={4}>
                                        <Item>
                                            <div>
                                                <b>{translate('max_cgm')} {' '} {isCurrentBloodSugar ? translate('glucose'): '전류'}</b>
                                            </div>
                                            <div>
                                                {Math.round(dataObject.maxGlucose)} {isCurrentBloodSugar ? 'mg/dL': 'nA'}
                                            </div>
                                        </Item>
                                    </Grid>
                                    <Grid xs={4}>
                                        <Item>
                                            <div>
                                                <b>{translate('min_cgm')} {' '} {isCurrentBloodSugar ? translate('glucose'): '전류'}</b>
                                            </div>
                                            <div>
                                                {Math.round(dataObject.minGlucose)} {isCurrentBloodSugar ? 'mg/dL': 'nA'}
                                            </div>
                                        </Item>
                                    </Grid>
                                    <Grid xs={4}>
                                        <Item>
                                            <div>
                                                <b>{translate('measurement_time')}</b>
                                            </div>
                                            <div>
                                                {dataObject.totalMeasurementTime}
                                            </div>
                                        </Item>
                                    </Grid>
                                    <Grid xs={4}>
                                        <Item>
                                            <div>
                                                <b>{translate('exceedUpper')}</b>
                                            </div>
                                            <div>
                                                {dataObject.exceedUpperPercent}% ({dataObject.exceedUpperTime})
                                            </div>
                                        </Item> 
                                    </Grid>
                                    <Grid xs={4}>
                                        <Item>
                                            <div>
                                                <b>{translate('exceedLower')}</b>
                                            </div>
                                            <div>
                                                {dataObject.exceedLowerPercent}% ({dataObject.exceedLowerTime})
                                            </div>
                                        </Item>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Box>
                    <Box sx={{width: '100%', height:'100%'}}>
                        <Card style={{height:'100%', border: '1px solid #5E2589'}}>
                            <CardContent style={{height:'100%'}}>
                                <Box style={{display:'flex', flexDirection:'column', height:'100%'}}> 
                                    <div style={{flex:'1', border:'0px solid #000000', borderRadius:'5px', padding:'10px', backgroundColor:'rgba(180, 180, 180, 0.23)', display:'flex', flexDirection:'row', alignItems:'center', justifyContent:'flex-start'}}> 
                                        <span style={{fontSize:'18px', fontWeight:'bold', marginLeft:'15px'}}>
                                            {translate('24_hours')} {isCurrentBloodSugar ? translate('glucose'): '전류'} {translate('data_statistics')}
                                        </span>
                                        
                                        {/* <Button variant="contained" size="medium" style={{ backgroundColor : '#DCD7E2', color:'#000000', fontSize:'16px', marginLeft:'auto'}} onClick={handleToWeeklyChart}> 
                                            <b>보고서 보기</b>
                                        </Button> */}
                                    </div>
                                    <Box style={{flex:'5'}}>
                                        {/* <Card style={{height:'100%', padding:'10px', border:'#5E2589 solid 1px'}}>
                                        
                                        </Card> */}
                                        <RangeAreaChart 
                                                middleAreaSeriesData = {middleAreaSeriesData} 
                                                mainUpperAreaSeriesData = {mainUpperAreaSeriesData} 
                                                mainLowerAreaSeriesData = {mainLowerAreaSeriesData} 
                                                lineSeriesData = {lineSeriesData} 
                                                upperLimit = {upperLimit}
                                                lowerLimit = {lowerLimit}
                                                height={600}/>
                                    </Box>
                                
                                </Box>
                                
                            </CardContent>
                        </Card>
                    </Box>
                </Stack>
                
            </div>
        
        </div>
    </div>
  );
}

export default withRouter(CGMreport);